// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-999dfc9e] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.modal-mask[data-v-999dfc9e] {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-mask--dark[data-v-999dfc9e] {
  background-color: rgba(0, 0, 0, 0.92);
}
.modal-header[data-v-999dfc9e] {
  position: absolute;
  z-index: 10001;
  top: 0;
  right: 0;
  left: 0;
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  overflow: hidden;
  transition: opacity 250ms, visibility 250ms;
}
.modal-header__name[data-v-999dfc9e] {
  overflow-x: hidden;
  box-sizing: border-box;
  width: 100%;
  padding: 0 132px 0 12px;
  transition: padding ease 100ms;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  margin-block: 0;
}
@media only screen and (min-width: 1024px) {
.modal-header__name[data-v-999dfc9e] {
    padding-left: 132px;
    text-align: center;
}
}
.modal-header .icons-menu[data-v-999dfc9e] {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.modal-header .icons-menu .header-close[data-v-999dfc9e] {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 3px;
  padding: 0;
}
.modal-header .icons-menu .play-pause-icons[data-v-999dfc9e] {
  position: relative;
  width: 50px;
  height: 50px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  border: none;
  background-color: transparent;
}
.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__play[data-v-999dfc9e],
.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__pause[data-v-999dfc9e], .modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__play[data-v-999dfc9e],
.modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__pause[data-v-999dfc9e] {
  opacity: 1;
  border-radius: 22px;
  background-color: rgba(127, 127, 127, 0.25);
}
.modal-header .icons-menu .play-pause-icons__play[data-v-999dfc9e], .modal-header .icons-menu .play-pause-icons__pause[data-v-999dfc9e] {
  box-sizing: border-box;
  width: 44px;
  height: 44px;
  margin: 3px;
  cursor: pointer;
  opacity: 0.7;
}
.modal-header .icons-menu[data-v-999dfc9e]  .action-item {
  margin: 3px;
}
.modal-header .icons-menu[data-v-999dfc9e]  .action-item--single {
  box-sizing: border-box;
  width: 44px;
  height: 44px;
  cursor: pointer;
  background-position: center;
  background-size: 22px;
}
.modal-header .icons-menu .header-actions[data-v-999dfc9e] button:focus-visible {
  box-shadow: none !important;
  outline: 2px solid #fff !important;
}
.modal-header .icons-menu[data-v-999dfc9e] .action-item__menutoggle {
  padding: 0;
}
.modal-header .icons-menu[data-v-999dfc9e] .action-item__menutoggle span, .modal-header .icons-menu[data-v-999dfc9e] .action-item__menutoggle svg {
  width: var(--icon-size);
  height: var(--icon-size);
}
.modal-wrapper[data-v-999dfc9e] {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* Navigation buttons */
  /* Content */
}
.modal-wrapper .prev[data-v-999dfc9e],
.modal-wrapper .next[data-v-999dfc9e] {
  z-index: 10000;
  height: 35vh;
  min-height: 300px;
  position: absolute;
  transition: opacity 250ms;
  color: white;
}
.modal-wrapper .prev[data-v-999dfc9e]:focus-visible,
.modal-wrapper .next[data-v-999dfc9e]:focus-visible {
  box-shadow: 0 0 0 2px var(--color-primary-element-text);
  background-color: var(--color-box-shadow);
}
.modal-wrapper .prev[data-v-999dfc9e] {
  left: 2px;
}
.modal-wrapper .next[data-v-999dfc9e] {
  right: 2px;
}
.modal-wrapper .modal-container[data-v-999dfc9e] {
  position: relative;
  display: flex;
  padding: 0;
  transition: transform 300ms ease;
  border-radius: var(--border-radius-large);
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);
}
.modal-wrapper .modal-container__close[data-v-999dfc9e] {
  z-index: 1;
  position: absolute;
  top: 4px;
  right: 4px;
}
.modal-wrapper .modal-container__content[data-v-999dfc9e] {
  width: 100%;
  min-height: 52px;
  overflow: auto;
}
.modal-wrapper--small > .modal-container[data-v-999dfc9e] {
  width: 400px;
  max-width: 90%;
  max-height: min(90%, 100% - 100px);
}
.modal-wrapper--normal > .modal-container[data-v-999dfc9e] {
  max-width: 90%;
  width: 600px;
  max-height: min(90%, 100% - 100px);
}
.modal-wrapper--large > .modal-container[data-v-999dfc9e] {
  max-width: 90%;
  width: 900px;
  max-height: min(90%, 100% - 100px);
}
.modal-wrapper--full > .modal-container[data-v-999dfc9e] {
  width: 100%;
  height: calc(100% - var(--header-height));
  position: absolute;
  top: 50px;
  border-radius: 0;
}
@media only screen and ((max-width: 512px) or (max-height: 400px)) {
.modal-wrapper .modal-container[data-v-999dfc9e] {
    max-width: initial;
    width: 100%;
    max-height: initial;
    height: calc(100% - var(--header-height));
    position: absolute;
    top: 50px;
    border-radius: 0;
}
}

/* TRANSITIONS */
.fade-enter-active[data-v-999dfc9e],
.fade-leave-active[data-v-999dfc9e] {
  transition: opacity 250ms;
}
.fade-enter[data-v-999dfc9e],
.fade-leave-to[data-v-999dfc9e] {
  opacity: 0;
}
.fade-visibility-enter[data-v-999dfc9e],
.fade-visibility-leave-to[data-v-999dfc9e] {
  visibility: hidden;
  opacity: 0;
}
.modal-in-enter-active[data-v-999dfc9e],
.modal-in-leave-active[data-v-999dfc9e],
.modal-out-enter-active[data-v-999dfc9e],
.modal-out-leave-active[data-v-999dfc9e] {
  transition: opacity 250ms;
}
.modal-in-enter[data-v-999dfc9e],
.modal-in-leave-to[data-v-999dfc9e],
.modal-out-enter[data-v-999dfc9e],
.modal-out-leave-to[data-v-999dfc9e] {
  opacity: 0;
}
.modal-in-enter .modal-container[data-v-999dfc9e],
.modal-in-leave-to .modal-container[data-v-999dfc9e] {
  transform: scale(0.9);
}
.modal-out-enter .modal-container[data-v-999dfc9e],
.modal-out-leave-to .modal-container[data-v-999dfc9e] {
  transform: scale(1.1);
}
.modal-mask .play-pause-icons .progress-ring[data-v-999dfc9e] {
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-90deg);
}
.modal-mask .play-pause-icons .progress-ring .progress-ring__circle[data-v-999dfc9e] {
  transition: 100ms stroke-dashoffset;
  transform-origin: 50% 50%;
  animation: progressring-999dfc9e linear var(--slideshow-duration) infinite;
  stroke-linecap: round;
  stroke-dashoffset: 94.2477796077;
  stroke-dasharray: 94.2477796077;
}
.modal-mask .play-pause-icons--paused .icon-pause[data-v-999dfc9e] {
  animation: breath-999dfc9e 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.modal-mask .play-pause-icons--paused .progress-ring__circle[data-v-999dfc9e] {
  animation-play-state: paused !important;
}
@keyframes progressring-999dfc9e {
from {
    stroke-dashoffset: 94.2477796077;
}
to {
    stroke-dashoffset: 0;
}
}
@keyframes breath-999dfc9e {
0% {
    opacity: 1;
}
50% {
    opacity: 0;
}
100% {
    opacity: 1;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcModal-6bpKFk4w.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,QAAQ;EACR,OAAO;EACP,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;AACA;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;AACA;;;EAGE,UAAU;EACV,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,uDAAuD;EACvD,yCAAyC;AAC3C;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gCAAgC;EAChC,yCAAyC;EACzC,8CAA8C;EAC9C,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;AACA;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;AACA;;AAEA,gBAAgB;AAChB;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,0EAA0E;EAC1E,qBAAqB;EACrB,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,mEAAmE;AACrE;AACA;EACE,uCAAuC;AACzC;AACA;AACA;IACI,gCAAgC;AACpC;AACA;IACI,oBAAoB;AACxB;AACA;AACA;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-999dfc9e] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.modal-mask[data-v-999dfc9e] {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.modal-mask--dark[data-v-999dfc9e] {\n  background-color: rgba(0, 0, 0, 0.92);\n}\n.modal-header[data-v-999dfc9e] {\n  position: absolute;\n  z-index: 10001;\n  top: 0;\n  right: 0;\n  left: 0;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50px;\n  overflow: hidden;\n  transition: opacity 250ms, visibility 250ms;\n}\n.modal-header__name[data-v-999dfc9e] {\n  overflow-x: hidden;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 132px 0 12px;\n  transition: padding ease 100ms;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 16px;\n  margin-block: 0;\n}\n@media only screen and (min-width: 1024px) {\n.modal-header__name[data-v-999dfc9e] {\n    padding-left: 132px;\n    text-align: center;\n}\n}\n.modal-header .icons-menu[data-v-999dfc9e] {\n  position: absolute;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.modal-header .icons-menu .header-close[data-v-999dfc9e] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  margin: 3px;\n  padding: 0;\n}\n.modal-header .icons-menu .play-pause-icons[data-v-999dfc9e] {\n  position: relative;\n  width: 50px;\n  height: 50px;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n}\n.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__play[data-v-999dfc9e],\n.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__pause[data-v-999dfc9e], .modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__play[data-v-999dfc9e],\n.modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__pause[data-v-999dfc9e] {\n  opacity: 1;\n  border-radius: 22px;\n  background-color: rgba(127, 127, 127, 0.25);\n}\n.modal-header .icons-menu .play-pause-icons__play[data-v-999dfc9e], .modal-header .icons-menu .play-pause-icons__pause[data-v-999dfc9e] {\n  box-sizing: border-box;\n  width: 44px;\n  height: 44px;\n  margin: 3px;\n  cursor: pointer;\n  opacity: 0.7;\n}\n.modal-header .icons-menu[data-v-999dfc9e]  .action-item {\n  margin: 3px;\n}\n.modal-header .icons-menu[data-v-999dfc9e]  .action-item--single {\n  box-sizing: border-box;\n  width: 44px;\n  height: 44px;\n  cursor: pointer;\n  background-position: center;\n  background-size: 22px;\n}\n.modal-header .icons-menu .header-actions[data-v-999dfc9e] button:focus-visible {\n  box-shadow: none !important;\n  outline: 2px solid #fff !important;\n}\n.modal-header .icons-menu[data-v-999dfc9e] .action-item__menutoggle {\n  padding: 0;\n}\n.modal-header .icons-menu[data-v-999dfc9e] .action-item__menutoggle span, .modal-header .icons-menu[data-v-999dfc9e] .action-item__menutoggle svg {\n  width: var(--icon-size);\n  height: var(--icon-size);\n}\n.modal-wrapper[data-v-999dfc9e] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  /* Navigation buttons */\n  /* Content */\n}\n.modal-wrapper .prev[data-v-999dfc9e],\n.modal-wrapper .next[data-v-999dfc9e] {\n  z-index: 10000;\n  height: 35vh;\n  min-height: 300px;\n  position: absolute;\n  transition: opacity 250ms;\n  color: white;\n}\n.modal-wrapper .prev[data-v-999dfc9e]:focus-visible,\n.modal-wrapper .next[data-v-999dfc9e]:focus-visible {\n  box-shadow: 0 0 0 2px var(--color-primary-element-text);\n  background-color: var(--color-box-shadow);\n}\n.modal-wrapper .prev[data-v-999dfc9e] {\n  left: 2px;\n}\n.modal-wrapper .next[data-v-999dfc9e] {\n  right: 2px;\n}\n.modal-wrapper .modal-container[data-v-999dfc9e] {\n  position: relative;\n  display: flex;\n  padding: 0;\n  transition: transform 300ms ease;\n  border-radius: var(--border-radius-large);\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);\n}\n.modal-wrapper .modal-container__close[data-v-999dfc9e] {\n  z-index: 1;\n  position: absolute;\n  top: 4px;\n  right: 4px;\n}\n.modal-wrapper .modal-container__content[data-v-999dfc9e] {\n  width: 100%;\n  min-height: 52px;\n  overflow: auto;\n}\n.modal-wrapper--small > .modal-container[data-v-999dfc9e] {\n  width: 400px;\n  max-width: 90%;\n  max-height: min(90%, 100% - 100px);\n}\n.modal-wrapper--normal > .modal-container[data-v-999dfc9e] {\n  max-width: 90%;\n  width: 600px;\n  max-height: min(90%, 100% - 100px);\n}\n.modal-wrapper--large > .modal-container[data-v-999dfc9e] {\n  max-width: 90%;\n  width: 900px;\n  max-height: min(90%, 100% - 100px);\n}\n.modal-wrapper--full > .modal-container[data-v-999dfc9e] {\n  width: 100%;\n  height: calc(100% - var(--header-height));\n  position: absolute;\n  top: 50px;\n  border-radius: 0;\n}\n@media only screen and ((max-width: 512px) or (max-height: 400px)) {\n.modal-wrapper .modal-container[data-v-999dfc9e] {\n    max-width: initial;\n    width: 100%;\n    max-height: initial;\n    height: calc(100% - var(--header-height));\n    position: absolute;\n    top: 50px;\n    border-radius: 0;\n}\n}\n\n/* TRANSITIONS */\n.fade-enter-active[data-v-999dfc9e],\n.fade-leave-active[data-v-999dfc9e] {\n  transition: opacity 250ms;\n}\n.fade-enter[data-v-999dfc9e],\n.fade-leave-to[data-v-999dfc9e] {\n  opacity: 0;\n}\n.fade-visibility-enter[data-v-999dfc9e],\n.fade-visibility-leave-to[data-v-999dfc9e] {\n  visibility: hidden;\n  opacity: 0;\n}\n.modal-in-enter-active[data-v-999dfc9e],\n.modal-in-leave-active[data-v-999dfc9e],\n.modal-out-enter-active[data-v-999dfc9e],\n.modal-out-leave-active[data-v-999dfc9e] {\n  transition: opacity 250ms;\n}\n.modal-in-enter[data-v-999dfc9e],\n.modal-in-leave-to[data-v-999dfc9e],\n.modal-out-enter[data-v-999dfc9e],\n.modal-out-leave-to[data-v-999dfc9e] {\n  opacity: 0;\n}\n.modal-in-enter .modal-container[data-v-999dfc9e],\n.modal-in-leave-to .modal-container[data-v-999dfc9e] {\n  transform: scale(0.9);\n}\n.modal-out-enter .modal-container[data-v-999dfc9e],\n.modal-out-leave-to .modal-container[data-v-999dfc9e] {\n  transform: scale(1.1);\n}\n.modal-mask .play-pause-icons .progress-ring[data-v-999dfc9e] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: rotate(-90deg);\n}\n.modal-mask .play-pause-icons .progress-ring .progress-ring__circle[data-v-999dfc9e] {\n  transition: 100ms stroke-dashoffset;\n  transform-origin: 50% 50%;\n  animation: progressring-999dfc9e linear var(--slideshow-duration) infinite;\n  stroke-linecap: round;\n  stroke-dashoffset: 94.2477796077;\n  stroke-dasharray: 94.2477796077;\n}\n.modal-mask .play-pause-icons--paused .icon-pause[data-v-999dfc9e] {\n  animation: breath-999dfc9e 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n.modal-mask .play-pause-icons--paused .progress-ring__circle[data-v-999dfc9e] {\n  animation-play-state: paused !important;\n}\n@keyframes progressring-999dfc9e {\nfrom {\n    stroke-dashoffset: 94.2477796077;\n}\nto {\n    stroke-dashoffset: 0;\n}\n}\n@keyframes breath-999dfc9e {\n0% {\n    opacity: 1;\n}\n50% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
